import axios from 'axios';
import { Company } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'https://makicheck.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const companyService = {
  async getCompanies(): Promise<Company[]> {
    const response = await api.get('/companies');
    return response.data;
  },

  async getAllCompanies(): Promise<Company[]> {
    const response = await api.get('/companies/all');
    return response.data;
  },

  async getCompany(id: number): Promise<Company> {
    const response = await api.get(`/companies/${id}`);
    return response.data;
  },

  async createCompany(companyData: {
    company_id?: string;
    name: string;
    pin: string;
    first_day_of_week: string;
    manager_id?: string | null;
    phone?: string;
    image_url?: string;
  }): Promise<Company> {
    const response = await api.post('/companies', companyData);
    return response.data;
  },

  async updateCompany(id: number, companyData: {
    company_id?: string;
    name: string;
    pin?: string;
    first_day_of_week: string;
    manager_id?: string | null;
    phone?: string;
    image_url?: string;
  }): Promise<Company> {
    const response = await api.put(`/companies/${id}`, companyData);
    return response.data;
  },

  async deleteCompany(id: number): Promise<void> {
    await api.delete(`/companies/${id}`);
  },

  async updateMyCredentials(data: { new_company_id?: string; new_pin?: string; company_id?: number }): Promise<any> {
    const response = await api.put('/companies/me/credentials', data);
    return response.data;
  },

  async getMyCompany(): Promise<any> {
    const response = await api.get('/companies/me');
    return response.data;
  },
};
